<template>
  <div class="border" style="width: 100%">
    <el-tree
      class="tree"
      ref="tree"
      :data="treeData"
      node-key="carrierId"
      :show-checkbox="mode === 'edit'"
      :props="treeProp"
      :default-checked-keys="checked.split(',')"
      :filter-node-method="filterNode"
      @check-change="handleCheckChange"
    ></el-tree>

    <template v-if="!hideButton">
      <el-button
        type="primary"
        class="w-100"
        @click="changeMode"
        v-if="mode === 'view'"
        >{{ $t('public.edit') }}
      </el-button>
      <el-button
        type="primary"
        class="w-100"
        @click="changeMode"
        v-if="mode === 'edit'"
        >{{ $t('public.btn_confirm') }}
      </el-button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    hideButton: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      default: () => []
    },
    checked: {
      type: String,
      default: ''
    },
    // 加一个参数直接显示树形，不需要点一次编辑
    loadNow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    treeData () {
      // 没有监测点为0的数据 也就是显示暂无数据
      this.$nextTick(() => {
        this.$refs.tree.filter('0')
      })
      if (!Object.keys(this.hash).length) {
        this.hashTree(this.treeData)
      }
    },
    checked: {
      immediate: true,
      handler () {
        if (this.checked) {
          if(!this.loadNow){
            this.$nextTick(() => {
              this.$refs.tree.filter(this.checked)
            })
          }
        }
      }
    }
  },
  computed: {
    treeProp () {
      return {
        children: 'item'
      }
    }
  },
  data () {
    return {
      mode: 'view', // edit|view,
      hash: {},
      carrierHash: {}
    }
  },
  mounted(){
    if(this.loadNow){
      // this.mode = 'edit'
      this.changeMode()
    }
  },

  methods: {
    changeMode () {
      if (this.mode === 'edit') {
        this.mode = 'view'
        const ids = this.$refs.tree.getCheckedKeys(true).filter(item => item)
        // 提供选中的监测点
        this.$refs.tree.filter(ids)
        const info = {}
        // 获取全路径
        ids.forEach(id => {
          info[id] = this.getFullPath(id)
          info[id].data = this.carrierHash[id]
        })

        this.$emit('onTreeConfirm', ids, info)
      } else {
        this.mode = 'edit'
        this.$refs.tree.filter()
      }
    },
    filterNode (value, data) {
      if (!value) {
        return data.carrierId
      } else {
        return data.carrierId && value.indexOf(data.carrierId) !== -1
      }
    },
    // Tree按照ID进行Hash
    hashTree (treeData) {
      if (!treeData || !treeData.length) {
        return
      }
      for (let i = 0; i < treeData.length; i++) {
        const id = treeData[i].sceneId || treeData[i].scopeId

        const carrierId = treeData[i].carrierId

        this.hash[id] = treeData[i]
        if (carrierId) {
          this.carrierHash[carrierId] = treeData[i]
        }
        this.hashTree(treeData[i].item)
      }
    },
    // 获取监测点全路径
    getFullPath (carrierId) {
      const path = []
      let node = this.carrierHash[carrierId]

      while (node) {
        path.splice(0, 0, node.label)
        node = this.hash[node.parentId]
      }

      return {
        fullPath: path,
        carrierId
      }
    },
    // 获取选择的安装点
    getTreeConfirm(){
      const ids = this.$refs.tree.getCheckedKeys(true).filter(item => item)
        // 提供选中的监测点
        this.$refs.tree.filter(ids)
        const info = {}
        // 获取全路径
        ids.forEach(id => {
          info[id] = this.getFullPath(id)
          info[id].data = this.carrierHash[id]
        })

        return ids
        // this.$emit('onTreeConfirm', ids, info)
    },
    // 当选择时触发
    handleCheckChange(){
      const checkedNodes = this.$refs.tree.getCheckedNodes(true).filter(item => item)
      this.$emit('treeCheckChange', checkedNodes)

    },
    handleSetCheckedNodes(nodes){
      this.$refs.tree.setCheckedNodes(nodes)
    }
  }
}
</script>
<style scoped lang="scss">
.tree {
  height: 200px;
  overflow-y: auto;
}
</style>
